import { http } from "../../utils/config";

const rewardAPI = {
    getList: (params = {}) => {
        const {
            page = 1,
            per_page = 15,
            search = "",
            status = "",
            sort_by = "created_at",
            sort_order = "desc",
        } = params;

        const queryParams = new URLSearchParams({
            page: page.toString(),
            per_page: per_page.toString(),
            sort_by,
            sort_order,
            ...(search && { search }),
            ...(status !== "" && { status }),
        });

        return http.get(`/api/v1/rewards/form?${queryParams}`);
    },

    // create: (data) => {
    //     return http.post('/api/v1/rewards/form', data);
    // },
    create: (data) => {
        return http.post('/api/v1/rewards/form', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    getById: (id) => {
        return http.get(`/api/v1/rewards/form/${id}`);
    },

    // update: (id, data) => {
    //     return http.put(`/api/v1/rewards/form/${id}`, data);
    // },

    // update: (id, data) => {
    //     return http.put(`/api/v1/rewards/form/${id}`, data, {
    //         headers: {
    //             'Content-Type': 'multipart/form-data',
    //         },
    //     });
    // },
    update: (id, data) => {
        return http.post(`/api/v1/rewards/form/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    delete: (id) => {
        return http.delete(`/api/v1/rewards/form/${id}`);
    },

    toggle: (id) => {
        return http.patch(`/api/v1/rewards/form/${id}/toggle-status`);
    },

    getPackageAll: (params = {}) => {
        return http.get(`/api/v1/rewards/gw/packages`, { params });
    },

    getTelcoAll: (params = {}) => {
        return http.get(`/api/v1/rewards/gw/telco`, { params });
    },

    khaosatSlug: (id) => {
        return http.get(`/api/v1/rewards/khaosat/${id}`);
    },

    guiKhaoSat: (id, data) => {
        return http.post(`/api/v1/rewards/khaosat/${id}`, data);
    },

    getSubmissionList: (id, params = {}) => {
        const {
            page = 1,
            per_page = 15,
            search = "",
            status = "",
            sort_by = "created_at",
            sort_order = "desc",
        } = params;

        const queryParams = new URLSearchParams({
            page: page.toString(),
            per_page: per_page.toString(),
            sort_by,
            sort_order,
            ...(search && { search }),
            ...(status !== "" && { status }),
        });

        return http.get(`/api/v1/rewards/submissions/${id}?${queryParams}`);
    },

    getSubmissionById: (id) => {
        return http.get(`/api/v1/rewards/submissions/${id}`);
    },

    sendRewardWithId: (id) => {
        return http.patch(`/api/v1/rewards/submissions/${id}/send`);
    },

};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
    return async (...args) => {
        try {
            const response = await apiFunction(...args);
            return response;
        } catch (error) {
            console.error("API Error:", error);

            // Handle different types of errors
            if (error.response) {
                // Server responded with error status
                const { status, data } = error.response;
                switch (status) {
                    case 400:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 401:
                        throw new Error("Bạn cần đăng nhập để thực hiện thao tác này");
                    case 403:
                        throw new Error("Bạn không có quyền thực hiện thao tác này");
                    case 404:
                        throw new Error("Không tìm thấy thông tin");
                    case 422:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 500:
                        // throw new Error("Lỗi server, vui lòng thử lại sau");
                        throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
                    default:
                        throw new Error(data.message || "Đã có lỗi xảy ra");
                }
            } else if (error.request) {
                // Network error
                throw new Error("Không thể kết nối đến server");
            } else {
                // Other error
                throw new Error(error.message || "Đã có lỗi xảy ra");
            }
        }
    };
};

// Wrapped API functions with error handling
export const rewardAPIWithErrorHandling = {
    getList: withErrorHandling(rewardAPI.getList),
    create: withErrorHandling(rewardAPI.create),
    getById: withErrorHandling(rewardAPI.getById),
    update: withErrorHandling(rewardAPI.update),
    delete: withErrorHandling(rewardAPI.delete),
    toggle: withErrorHandling(rewardAPI.toggle),

    getPackageAll: withErrorHandling(rewardAPI.getPackageAll),
    getTelcoAll: withErrorHandling(rewardAPI.getTelcoAll),

    khaosatSlug: withErrorHandling(rewardAPI.khaosatSlug),
    guiKhaoSat: withErrorHandling(rewardAPI.guiKhaoSat),

    getSubmissionList: withErrorHandling(rewardAPI.getSubmissionList),
    getSubmissionById: withErrorHandling(rewardAPI.getSubmissionById),
    sendRewardWithId: withErrorHandling(rewardAPI.sendRewardWithId),
};

export default rewardAPI;
